/* eslint-disable @typescript-eslint/no-explicit-any */
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {DeployService} from "@/service/DeployService.ts";
import {ActionType} from "@/util/type/store.ts";
import {DeploymentResponse} from "@/model/response/deploy/DeploymentResponse.ts";


export type DeployState = {
    loading: boolean;
    swaggerUrl: string
    error: string
    deployModal: boolean
    selectedAppId: number

};

const initialState: DeployState = {
    loading: false,
    swaggerUrl: "",
    error: "",
    deployModal: false,
    selectedAppId: 0
};

const action = {
    create: createAsyncThunk(
        "deploy/create",
        async (payload: ActionType<number>, thunkAPI) => {
            return (await DeployService.deployApplication(thunkAPI, payload.data)).data;
        }
    ),
};

const slice = createSlice({
    name: "deployApplication",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        setDeployModal(state, {payload}) {
            state.deployModal = payload;
        },
        setSelectedAppId(state, {payload}) {
            state.selectedAppId = payload;
        },
        setSwaggerUrl(state, {payload}) {
            state.swaggerUrl = payload;
        },
        reset: () => ({...initialState})
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.create.fulfilled, (state, action) => {
                const response = action.payload as DeploymentResponse;
                state.loading = false;
                state.swaggerUrl = response.apiUrl
                if (response.responseCode == "00") {
                    state.deployModal = true
                    action.meta.arg.onSuccess?.(action.payload);
                } else {
                    action.meta.arg.onError?.(action.payload);
                }
            }).addCase(action.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'An error occurred';
        });
    },
});

export const deploy = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
